// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.plot-wrapper[data-v-62fee0fb] {\r\n  display: block;\r\n  position: absolute !important;\n}\n.plot-control-panel[data-v-62fee0fb] {\r\n  display: inline-block;\r\n  width: calc(100% - 70px);\r\n  margin-left: 70px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
